// extracted by mini-css-extract-plugin
export default {"container":"notification_watcher_title-module__container--ep1U9"};